"use client";

import type { Locale } from "@/types/insights";
import { useLocale } from "next-intl";
import dynamic from "next/dynamic";

const InsightsMotif3D = dynamic(() => import("./InsightsMotif3D"), { ssr: false });

/** Typographic header with a floating 3D motif. */
export default function InsightsHeader() {
  const locale = useLocale() as Locale;
  const ar = locale === "ar";
  return (
    <header className="relative mx-auto max-w-360 overflow-hidden border-b border-black/10 px-6 pb-10 pt-24 lg:px-10 dark:border-white/10">
      <div className="pointer-events-none absolute inset-e-6 top-16 hidden h-56 w-56 opacity-90 md:block">
        <InsightsMotif3D />
      </div>
      <span className="text-[11px] uppercase tracking-widest text-accent">
        © {ar ? "المجلّة — (تحاور ٢٠١٣–٢٠٢٦)" : "JOURNAL — (TH 2013–2026)"}
      </span>
      <h1 className="mt-2 font-bebas text-[clamp(3rem,8vw,7rem)] uppercase leading-none text-ash dark:text-white">
        {ar ? "الرؤى" : "Insights"}
      </h1>
      <span className="mt-3 block text-[11px] uppercase tracking-widest text-ash/50 dark:text-white/50">
        {ar ? "ملاحظات ورؤى من السوق العقاري" : "Field notes & market insights"}
      </span>
    </header>
  );
}
